import { DatePipe, Location } from '@angular/common';
import { ChangeDetectorRef, Component, Input, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AddProfileComponent } from 'src/app/AddThings/add-profile/add-profile.component';
import { AddPulledCustomerRecordComponent } from 'src/app/AddThings/add-pulled-customer-record/add-pulled-customer-record.component';
import { ConstructAPI } from 'src/app/API/constructAPI';
import { RestApiService } from 'src/app/API/restapi';
import { ALERT_TYPE } from 'src/app/constants';
import { LoanRequestListComponent } from 'src/app/LoanRequest/loan-request-list/loan-request-list.component';
import { ReserveHistoryComponent } from 'src/app/Reserve/reserve-history/reserve-history.component';
import { AlertDialogComponent } from 'src/app/Shared/alert-dialog/alert-dialog.component';
import { ConfirmationDialogComponent } from 'src/app/Shared/confirmation-dialog/confirmation-dialog.component';
import { Enums } from 'src/app/Shared/enums';
import { SharedService } from 'src/app/Shared/shared-service.service';
import { Commission } from 'src/model/commission.model';
import { Contact } from 'src/model/contact.model';
import { Customer } from 'src/model/customer.model';
import { DuitLebih } from 'src/model/duitLebih.model';
import { EPF } from 'src/model/epf.model';
import { LoanRequest } from 'src/model/loanRequest.model';
import { Profile } from 'src/model/profile.model';
import { Status } from 'src/model/status.model';
import { CustomerService } from 'src/services/customer.service';
import { EpfService } from 'src/services/epf.service';
import { LoanRequestService } from 'src/services/loan-request.service';
import { ProfileService } from 'src/services/profile.service';
import { CustomerBdHistoryComponent } from '../customer-bd-history/customer-bd-history.component';
import { CustomerTransactionsComponent } from '../customer-transactions/customer-transactions.component';
import { IcChangeHistoryComponent } from '../ic-change-history/ic-change-history.component';
import { MergeProfileComponent } from '../merge-profile/merge-profile.component';
import { ShareProfileToCompanyComponent } from '../share-profile-to-company/share-profile-to-company.component';
import { UpdateCustomerComponent } from '../update-customer/update-customer.component';
import { ViewEpfChangeHistoryComponent } from '../view-epf-change-history/view-epf-change-history.component';

@Component({
    selector: 'app-manage-customer',
    templateUrl: './manage-customer.component.html',
    styleUrls: ['./manage-customer.component.scss'],
    standalone: false
})
export class ManageCustomerComponent {
  private activatedRoute = inject(ActivatedRoute);
  private restapi = inject(RestApiService);
  private constructApi = inject(ConstructAPI);
  protected enums = inject(Enums);
  protected sharedService = inject(SharedService);
  private location = inject(Location);
  private cdr = inject(ChangeDetectorRef);
  private datepipe = inject(DatePipe);
  private epfService = inject(EpfService);
  private customerService = inject(CustomerService);
  private profileService = inject(ProfileService);
  private loanRequestService = inject(LoanRequestService);

  viewCustomer: Customer;
  @Input() allowUpdateTask = true;
  @Input() selectedCustomerID: number;
  // viewCustCode: number;
  customerEpfDetails: EPF;

  commissionList: Commission[] = [];
  routeSubscription: any;
  selectedProfile: Profile;
  selectedProfileID: number;
  processedStatusCode: number;

  loanRequestList: LoanRequest[] = [];
  sharedProfiles: Profile[] = [];

  constructor() {
    this.routeSubscription = this.activatedRoute.paramMap.subscribe(params => {
      this.selectedCustomerID = +params.get('customerId');
      if (params.get('profileId') != undefined)
        this.selectedProfileID = +params.get('profileId');
      else
        this.selectedProfileID = undefined

      //reset epf details every time
      this.customerEpfDetails = undefined;
      this.getCustomerInfos();
    })
  }

  getCustomerStatus(status: Status[]) {
    const statusCode = this.sharedService.processStatusCode(status);
    return this.enums.customerStatusString[statusCode - 1];
  }

  getStatusColor(status: Status[]) {
    let color: string;
    const statusCode = this.sharedService.processStatusCode(status);
    switch (statusCode) {
      case this.enums.ACTIVE_CUST:
        color = "bg-primary";
        break;
      case this.enums.WARNING_CUST:
        color = "bg-warning";
        break;
      case this.enums.BAD_DEBT_CUST:
        color = "bg-dark";
        break;
      case this.enums.CP_CUST:
        color = "bg-info";
        break;
      case this.enums.LBD_CUST:
        color = "bg-secondary";
        break;
      default:
        color = "bg-success";
        break;
    }
    return color;
  }

  getStatusPanelColor(status: Status[]) {
    const statusCode = this.sharedService.processStatusCode(status);
    switch (statusCode) {
      case this.enums.ACTIVE_CUST:
        return "activePanel";
      case this.enums.BAD_DEBT_CUST:
        return "badDebtPanel";
      case this.enums.WARNING_CUST:
        return "warningPanel";
      case this.enums.CP_CUST:
        return "cpPanel";
      case this.enums.LBD_CUST:
        return "legalPanel";
      default:
        return "activePanel";
    }
  }

  openAddProfileModal() {
    const modalRef = this.sharedService.openModal(AddProfileComponent, "largeModal");
    modalRef.componentInstance.addProfileCustomerId = this.viewCustomer.ID;

    if (modalRef.componentInstance.passEntry != undefined) {
      modalRef.componentInstance.passEntry.subscribe((entry) => {
        const profile: Profile = entry;
        this.viewCustomer.Profiles.push(profile);
      });

      modalRef.result.then(() => {
      })
    }
  }

  openEditProfileModal() {
    const modalRef = this.sharedService.openModal(UpdateCustomerComponent);
    modalRef.componentInstance.customerToUpdate = this.viewCustomer;
    modalRef.componentInstance.epfDetails = this.customerEpfDetails;

    if (modalRef.componentInstance.passEntry != undefined) {
      modalRef.componentInstance.passEntry.subscribe((entry) => {
        if (entry == true)
          this.getCustomerInfos();
      });

      modalRef.result.then(() => {
      })
    }
  }
  openCustomerTransactionModal() {
    const modalRef = this.sharedService.openModal(CustomerTransactionsComponent, "largeModal");
    modalRef.componentInstance.profileId = this.selectedProfile.ID;
    modalRef.componentInstance.companyId = this.viewCustomer.CompanyId;
    modalRef.componentInstance.epfDate = this.viewCustomer.EPFDate;
  }

  openReserveHistory() {
    const modalRef = this.sharedService.openModal(ReserveHistoryComponent, "largeModal");
    modalRef.componentInstance.selectedProfileID = this.selectedProfileID;
    modalRef.componentInstance.selectedProfile = this.selectedProfile;

    if (this.selectedProfile.SharedProfileId != undefined)
      modalRef.componentInstance.sharedProfileId = this.selectedProfile.SharedProfileId;

    modalRef.componentInstance.totalReserveAmount = this.selectedProfile.Reserve;
    modalRef.componentInstance.viewCustomer = this.viewCustomer;

    modalRef.componentInstance.profileList = this.viewCustomer.Profiles;

    if (modalRef.componentInstance.passEntry != undefined) {
      modalRef.componentInstance.passEntry.subscribe((amount) => {
        const addedSimpan = amount;

        //append added account to account list
        this.viewCustomer.Reserve += addedSimpan;
      });

      modalRef.result.then(() => {
      })
    }
  }

  openBadDebtHistory() {
    const modalRef = this.sharedService.openModal(CustomerBdHistoryComponent, "largeModal");
    modalRef.componentInstance.selectedProfileID = this.selectedProfileID;
    modalRef.componentInstance.selectedCustomerName = this.viewCustomer.Name;
  }

  openLoanRequestList() {
    const modalRef = this.sharedService.openModal(LoanRequestListComponent, "largeModal");
    modalRef.componentInstance.loanRequestList = this.loanRequestList;
  }

  isStaff() {
    const roleId = Number(sessionStorage.getItem('roleId'));

    if (roleId == this.enums.STAFF)
      return true;
    else
      return false;
  }

  async getCustomerInfos() {
    this.viewCustomer = await this.customerService.getCustomerDetails(this.selectedCustomerID);
    if (this.viewCustomer.EPFDate != undefined) this.customerEpfDetails = await this.epfService.getCustomerEPF(this.selectedCustomerID);

    const profileIds = this.viewCustomer.Profiles.map(p => p.ID);
    this.viewCustomer.Profiles = await this.profileService.getAllProfiles(profileIds);

    if (this.selectedProfileID !== undefined) {
      if (!profileIds.includes(this.selectedProfileID)) {
        console.error("Profile ID " + this.selectedProfileID + " is not found for this customer");
        return;
      }
      await this.setSelectedProfile(this.selectedProfileID);

      // * Update profile dropdown when profile details updated
      const i = this.viewCustomer.Profiles.findIndex(p => Number(p.ID) === Number(this.selectedProfile.ID));
      this.viewCustomer.Profiles[i] = this.selectedProfile;

      this.updateURL();
    } else {
      this.selectedProfileID = this.viewCustomer.Profiles[0].ID;
      await this.setSelectedProfile(this.selectedProfileID);
    }
    this.viewCustomer.Status = this.sharedService.processStatusCode(this.selectedProfile.Status);
  }

  async setSelectedProfile(id: number) {
    const profile = await this.profileService.getProfile(id);

    this.selectedProfile = profile;

    if (this.sharedService.isBranchAccountHandler() == true || this.sharedService.isStaff())
      this.getProfileLoanRequest(this.selectedProfileID, false);
    else if (this.sharedService.isAdmin() || this.sharedService.isBossAccount() || this.sharedService.isFinance())
      this.getProfileLoanRequest(this.selectedProfileID, undefined);
  }

  updateURL() {
    const urls = window.location.pathname.split("/");
    if (window.location.pathname.includes('manageCustomer'))
      this.location.replaceState(urls[1] + "/" + urls[2] + "/" + this.selectedProfileID);
    else
      this.location.replaceState(urls[1] + "/" + urls[2] + "/" + urls[3] + "/" + this.selectedProfileID);
  }

  async getProfileLoanRequest(profileId: number, withLoan: boolean) {
    this.loanRequestList = [];
    this.loanRequestList = await this.loanRequestService.getProfileLoanApprovalRequest(profileId, { withLoan: withLoan });
    if (this.sharedService.isBranchAccountHandler())
      this.loanRequestList = this.loanRequestList.filter(r => r.Approved !== false);
    this.cdr.detectChanges();
  }

  processGuarantorJsonArr(jsonArray: any) {
    const guarantorsInfo: Contact[] = [];
    jsonArray.forEach(json => {
      const guarantors = new Contact(json.id, json.name, json.icNumber, json.number, json.address, json.customerId, json.relation, json.remark)
      guarantorsInfo.push(guarantors);
    });

    return guarantorsInfo;
  }

  processDuitLebihJsonArr(jsonArray: any) {
    const duitLebihList: DuitLebih[] = [];
    jsonArray.forEach(json => {
      const extra = new DuitLebih(json.amount, json.subtype)
      duitLebihList.push(extra);
    });

    return duitLebihList;
  }

  openAlert(message: string) {
    const modalRef = this.sharedService.openModal(AlertDialogComponent);
    modalRef.componentInstance.message = message;
  }

  openMergeProfileModal() {
    const modalRef = this.sharedService.openModal(MergeProfileComponent, 'largeModal');
    modalRef.componentInstance.profileList = this.viewCustomer.Profiles;
    modalRef.componentInstance.selectedProfile = this.selectedProfile;
    modalRef.componentInstance.selectedCustomer = this.viewCustomer;
  }

  openShareProfileModal() {
    const modalRef = this.sharedService.openModal(ShareProfileToCompanyComponent, 'largeModal');
    modalRef.componentInstance.currentProfile = this.selectedProfile;
  }

  confirmBeforeUnshare() {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to UNSHARE this profile ?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.unshareProfile();
    });
  }

  confirmBeforeMarkAsMain() {
    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    modalRef.componentInstance.message = "Are you sure you want to MARK this profile AS MAIN SHARED PROFILE?";

    modalRef.result.then((confirm) => {
      if (confirm)
        this.markProfileAsShare();
    });
  }

  markProfileAsShare() {
    const xhr = this.restapi.putRequest(this.constructApi.getMarkProfileAsMainShared(Number(this.viewCustomer.ID), Number(this.selectedProfile.ID)));
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          //if success emit
          // this.passEntry.emit();
          window.location.reload();
          this.sharedService.openAlert("Successfully mark as MAIN profile!", ALERT_TYPE.SUCCESS)
        }
        else {
          this.sharedService.openErrorMessage(xhr);
        }
      }
    }
  }
  unshareProfile() {
    const xhr = this.restapi.patchRequest(this.constructApi.getUnshareProfile(Number(this.selectedProfile.ID)));
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        if (xhr.status == 200) {
          //if success emit
          // this.passEntry.emit();
          window.location.reload();
          this.sharedService.openAlert("Successfully unshared profile!", ALERT_TYPE.SUCCESS)
        }
        else {
          this.sharedService.openErrorMessage(xhr);
        }
      }
    }
  }

  viewCustomerEPFHistory(viewCustomer: Customer) {
    const modalRef = this.sharedService.openModal(ViewEpfChangeHistoryComponent, 'largeModal');
    modalRef.componentInstance.customerId = viewCustomer.ID;
  }

  viewCustomerICHistory(viewCustomer: Customer) {
    const modalRef = this.sharedService.openModal(IcChangeHistoryComponent, 'regularModal');
    modalRef.componentInstance.customerId = viewCustomer.ID;
  }

  confirmBeforeVerifyCustomer(isVerify: boolean, customerID: number) {
    let errorMessage = "";
    if (this.customerEpfDetails.Date != undefined && isVerify == true) {
      const isDOBValidWithIC = this.sharedService.isDOBValidWithIC(this.viewCustomer.ICNumber, new Date(this.viewCustomer.DOB));
      const isEPFDateValid = this.sharedService.isEPFDateValid(new Date(this.viewCustomer.DOB), new Date(this.customerEpfDetails.Date));

      if (isDOBValidWithIC == false)
        errorMessage += "Date Of Birth (" + this.datepipe.transform(this.viewCustomer.DOB, "dd-MM-yyyy") + ") not same with IC (" + this.viewCustomer.ICNumberWithDash + ") \n\n";

      if (isEPFDateValid == false) {
        const calculatedEPFDate = new Date(this.sharedService.calculateEPFDate(new Date(this.viewCustomer.DOB)));
        errorMessage += "Calculated EPF Date (" + this.datepipe.transform(calculatedEPFDate, "dd-MM-yyyy") + ") not same with User defined EPF Date (" + this.datepipe.transform(this.customerEpfDetails.Date, "dd-MM-yyyy") + ")  \n\n";
      }
    }

    const modalRef = this.sharedService.openModal(ConfirmationDialogComponent);
    const verifyMessage = (isVerify == true) ? "VERIFY" : "UNVERIFY";
    modalRef.componentInstance.message = (errorMessage == "") ? "Confirm to " + verifyMessage + " this customer?" : "There are some error(s):\n" + errorMessage + "Confirm to " + verifyMessage + " this customer?";
    modalRef.result.then((confirm) => {
      if (confirm) {
        if (isVerify == true)
          this.verifyCutsomer(customerID);
        else
          this.unverifyCutsomer(customerID);
      }
    });
  }

  verifyCutsomer(customerID: number) {
    const xhr = this.restapi.postRequest(this.constructApi.getVerifyCustomer(customerID));
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        // var json = JSON.parse(xhr.responseText);

        if (xhr.status == 200) {
          this.viewCustomer.Verified = true;
          this.viewCustomer.VerifiedBy = sessionStorage.getItem("username");
          this.viewCustomer.VerifiedOn = new Date();
        } else
          this.sharedService.openErrorMessage(xhr);
      }
    }
  }

  unverifyCutsomer(customerID: number) {
    const xhr = this.restapi.postRequest(this.constructApi.getUnverifyCustomer(customerID));
    xhr.onreadystatechange = () => {
      if (xhr.readyState == 4) {
        // var json = JSON.parse(xhr.responseText);

        if (xhr.status == 200) {
          this.viewCustomer.Verified = false;
        } else
          this.sharedService.openErrorMessage(xhr);
      }
    }
  }

  openPullCustomerModal() {
    const modalRef = this.sharedService.openModal(AddPulledCustomerRecordComponent, 'largeModal');
    modalRef.componentInstance.selectedCustomer = this.viewCustomer;
  }
}
